export default __webpack_public_path__ + "static/media/job_offer8_xl.a23159b0.jpg";